<template>

  <div id="app" :class="[{current:!loading},$route.name]" v-if="!loading">
    <div id="nav" v-if='$store.state.navbar' ref="navbar">
      <template v-if="$store.state.logo">
        <img v-if="$store.state.theme " :src="resources['logo_white'].src" class="logo">
        <img v-else :src="resources['logo'].src" class="logo"/>
      </template>
      <template v-for="(route,index) in routes">
        <template v-if="route.cname">
          <template v-if="!route.children">
          <router-link :class="[$store.state.theme,route.name] " class="link nav-item" :to="route.path" :key="index">
            <span class="nav-item-name">{{route.name}}</span>
            <span class="nav-item-cname">{{route.cname}}</span>
          </router-link>
        </template>
        <template v-else>
          <router-link :class="[$store.state.theme,route.name]" class="nav-subitem nav-item"  :to="route.path" :key="index">
            <span class="nav-item-name">{{route.name}}</span>
            <span class="nav-item-cname">{{route.cname}}</span>
            <div class="subnav">
              <template v-for="r in route.children" >
                <router-link class="sub-link" v-if='r.cname' :to="{name:r.path}" :key="r.index" >
                  <span>{{r.cname}}</span>
                </router-link>
              </template>
            </div>
          </router-link>
        </template>
        </template>
      </template>
      
      <div class="navbar-indicator" :class="$store.state.theme"></div>
     
    </div>

    <div class="slide-nav" v-if="$store.state.navbar">
      <template v-for="(route,index) in routes">
        <template v-if="route.cname">
          <router-link class="slide-nav-link" :class="[$store.state.theme,route.name] " :to="route.path" :key="index">
          </router-link>
        </template>
      </template>

    </div>


    <router-view/>
  </div>
  <div id="loading-page" class="loading-page" :class="{'play-animation':playAnimation,'play-frames':playFrames}" v-else>
    <div class="loading-wrapper" @transitionend.once="enterPage"  @webkitTransitionEnd.once="enterPage" >
      
      <div class="loading-top light" @webkitTransitionEnd.prevent.stop @transitionend.prevent.stop >
        <div class="loading-main">
          <div class="loading-text">
            <div class="cname">
              <template v-for="(t,index) in '做本土的国际公司'">
                <span  v-if="index==7" :key="index "  @transitionend.once="changePage" @webkitTransitionEnd.once="changePage">{{t}}</span>
                <span  v-else :key="index">{{t}}</span>
              </template>
            </div>
            <div class="ename">Local international companY</div>
          </div>
        </div>
      </div>
      <div class="loading-bottom light" @webkitTransitionEnd.prevent.stop @transitionend.prevent.stop>
        <div class="loading-main">
          <div class="loading-text">
            <div class="ename">International local companY</div>
            <div class="cname">
              <span v-for="(t,index) in '国际的本土公司'" :key="index">{{t}}</span>
              <em></em>
            </div>
          </div>
        </div>
        
      </div>
    </div>

    <div class="progress" v-if="!playAnimation" :style="{width:percentage+'%'}"></div>
    
  </div>

</template>
<script>
import {manifest} from "./assets/resources.json";
import { userAgent } from 'ua_parser'
var { browser } = userAgent(navigator.userAgent)
var { name, version } = browser; var { major } = version
export default {
  data(){
    return {
      loading:true,
      routes:[],
      playAnimation:false,
      playFrames: false,
      percentage:0,
      resources:null
    }
  },
  created(){
    this.routes = this.$router.options.routes;
    this.remFix();
  },
  mounted(){
    if(name === 'msie' && major < 10 ){
      return;
    }
    this.loading = true;
    let loader = this.PreloadResource(manifest);
    loader.addLoadProgress((loaded,total)=>{
      let percent = Math.round( 100 * loaded / total);
      this.percentage = percent;
    });
    loader.addLoadComplete((id,src,loaded,total)=>{
     
      this.percentage = 100;
      this.resources = this.$store.state.resources;
      this.loadFinish();
    });
    loader.start();


    
  },
  methods:{
    loadFinish(){
      this.playAnimation = true;
    },
    changePage(){
      setTimeout(() => {
        this.playFrames = true;
      }, 1000);
    },
    enterPage(){
      // return ;
      this.loading = false;
      this.$nextTick(()=>{
        let navbar = this.$refs.navbar ;
        if(navbar) {
          let links = navbar.querySelectorAll(".nav-item");
          let indicator = navbar.querySelector(".navbar-indicator");
          console.log(links);
          for(var i = 0 ,len = links.length ; i < len ; i ++){
            let link = links[i];
            link.onmouseover = function(){
              let {left} = this.getBoundingClientRect();
              indicator.style.left = left + 'px';
            }
          }
          navbar.onmouseout = init;

          function init(){
            let link = navbar.querySelector(".router-link-active");
            if(!link) return ;
            let {left,width} = link.getBoundingClientRect();
            indicator.style.left = left +'px';
            indicator.style.width = width + 'px';
          }
          init();
        }
        
      })
      
    }
  }
}

</script>

<style lang="scss">
  @import "./common/common.scss";
  @import "./common/theme.scss";
html,
body{
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #eeeeee;
  font-family: source-han-sans-simplified-c, sans-serif;
}
#app {
  width: 100%;
  height: 100%;
}
a {
  color:inherit;
  text-decoration: none;
}
.logo {
  position:absolute;
  
  @media all and (min-width:1200px) {
    left: px2rem(40);
  }
  @media all and (min-width:1600px) {
    left: 0;
    right: 0;
    margin: auto;
  }
  
  top: 50%;
  transform: translate(0,-80%);
  width: px2rem(139);
  pointer-events: none;
}
#nav {
  z-index: 1000;
  position: absolute;
  left: 0;
  right: 0;
  box-sizing: border-box;
  padding: px2rem(54) px2rem(40);
  margin: auto;
  display: flex;
  justify-content: flex-end;
  text-align: center;
  line-height: 1;
  text-transform: uppercase;
  font-size: px2rem(14);
  font-size: 14px; 
}
.nav-item {
  display: inline-block;
  position: relative;
  width: 83px;
  color: #000;
  font-size: 14px;
  cursor: pointer;
  + .nav-item {
    border-left: 1px solid #000;
  }
  &:hover,
  &.router-link-active {
    color: $themeColor;
    &.white {
      color: #fff;
    }
    .nav-item-name {
      opacity: 0;
    }
    .nav-item-cname {
      opacity: 1;
      transform: none;
    }
   
  }
  &:hover{
    .subnav {
      transform: none;
    }
    @for $v from 1 to 4 {
      .sub-link:nth-child(#{$v}){
        transform: none;
        transition: all .4s .2s * $v ease-in;
      }
    }
  }
  
}
.nav-item-cname {
  opacity: 0;
  transform: translate(0,20%);
  transition: all .2s ease-out;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.subnav {
  position:absolute;
  left: 0;
  width: 100%;
  padding-top: 8px;
  text-align: center;
  perspective: 1000px;
  transform: scale(0);
}
.sub-link {
  transform: rotateY(90deg);
  line-height: 1;
  text-decoration: none;
  width: 100%;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: $themeColor;
  position: relative;
  overflow: hidden;
  
  .white &{
    background-color: #fff;
    color: $themeColor;
    &:before {
      left: 2px;
      border-left-color: $themeColor;
      transform: translate(-100%,0);
    }
    &:after {
      right: 2px;
      border-right-color: $themeColor;
      transform: translate(100%,0);
    }
  }
  &:hover,
  &.router-link-active {
    &:before,
    &:after {
      opacity: 1;
      transform: none;
    } 
  }
  &:before,
  &:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border: 6px solid transparent;
    top: 0;
    bottom: 0;
    margin: auto 0 ;
    opacity: 0;
    transition: all .1s linear;
  }
  &:before {
    left: 2px;
    border-left-color: #fff;
    transform: translate(-100%,0);
  }
  &:after {
    right: 2px;
    border-right-color: #fff;
    transform: translate(100%,0);
  }
  + .sub-link {
    margin-top: 3px;
  }
}

.slide-nav {
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translate(0,-50%);
  z-index: 999;
  .slide-nav-link {
    
    display: block;
    width: 8px;
    height: 8px;
    border:2px solid #fff;
    border-radius: 50%;
    background: #fff;
    + .slide-nav-link  {
      margin-top: 14px;
    }
    &.router-link-active {
      background: $themeColor;
    }
  }
}
// #app.current {
//   .slide-nav-link,
//   .nav-item {
//     @for $v from 1 to 10  {
//       &:nth-child(#{$v}){
//         transform: none;
//         opacity: 1;
//         transition: all .3s .15s * $v + 2s linear
//       }
//     }
//   }
  
// }


#loading-page{
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
  top: 0;
  left: 0;
  text-transform: uppercase;
  line-height: 1;
}
.loading-wrapper {
  position: absolute;
  width: 100%;
  height: 0;
  top: 50%;
  transform-origin: center center;
  .loading-top,
  .loading-bottom {
    padding: 100%;
    position: absolute;
    left: 50%;
    transform: translate(-50%,0);
  }
  .loading-main {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .loading-text {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
    overflow: hidden;
    transition: font .1s linear;
  }
  .cname,
  .ename {
    display: inline-block;
    overflow: hidden;
  }
  .cname {
    font-size: 48px;
    letter-spacing: .1em;
  }
  .ename {
    font-size: 24px;
  }
  em {
    padding: 0 .5em;
  }
}

.loading-top {
  bottom: 0;
  color: $themeColor;
  .loading-main {
    background: #eeeeee;
  }
  .cname {
    margin-right: 12px;
  }
  .loading-text {
    bottom: 13px;
    
  }
}
.loading-bottom{
  top: 0;
  color: #fff;
  .loading-main {
    transform-origin: left top;
    background: $themeColor;
    transform: scaleY(0);
  }
  .cname,
  .ename {
    vertical-align: text-top;
  }
  .cname {
    margin-left: 12px;
  }
  .loading-text {
    top: 13px;
   
  }
  
}
.loading-top  {
  .ename {
    transform: translate(20%,0);
    opacity: 0;
  }
  .cname {
    span {
      display: inline-block;
      transform: translate(0,110%);
    }
  }
}
.loading-bottom {
  .ename {
    transform: translate(-20%,0);
    opacity: 0;
  }
  .cname {
    span {
      display: inline-block;
      transform: translate(0,-110%);
    }
  }

}
.progress {
  position: absolute;
  height: 6px;
  background: $themeColor;
  top: 50%;
  left: 0;
  transition: width .6s ease;
}
.loading-page {
  &.play-animation {
    .loading-bottom {
      .loading-main {
        transform: none;
        transition: all .5s linear;
      }
    }
    .ename {
      transform: none;
      opacity: 1;
      transition: all .5s linear;
    }
    span {
      @for $v from 1 to 9 {
        &:nth-child(#{$v}){
          transform: none;
          transition: all .5s .3s * $v linear;
        }
      }
    }
  }
  &.play-frames {
    .loading-wrapper {
      transform: rotate(90deg);
      transition: all .5s linear;
    }
    .loading-top {
      .cname,
      .ename {
        transform: translate(0,100%);
        transition: all .3s linear;
      }
    }
    .loading-bottom {
      .cname,
      .ename {
        transform: translate(0,-100%);
        transition: all .3s linear;
      }
    }
  }
}
.navbar-indicator {
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 4px;
  background: $themeColor;
  transition: left .5s ease;
  &.white {
    background: #fff;
  }
}

</style>
